<template>
  <div class="approval-leave-list-search-bar">
    <div class="content">
      <div>
        <kd-icon icon="search"></kd-icon>
      </div>
      <kd-input
        v-model="batchProcessQuery.keyword"
        placeholder="学生姓名/学籍号"
        @change="textChangeHandle"
        @input="textChangeHandle"
        @focus="toggleFilterPannel()"
      ></kd-input>
    </div>
    <div class="select">
      <div @click="toggleFilterPannel('clazz')" :class="{ active: showClazzChoose, working: showClazzChoose }">
        <span>{{ showClazzValue }}</span>
        <kd-icon icon="triangle"></kd-icon>
      </div>
      <div @click="toggleFilterPannel('type')" :class="{ active: showSelectType, working: showSelectType }">
        <span>{{ showTypeValue }}</span>
        <kd-icon icon="triangle"></kd-icon>
      </div>
      <div @click="toggleFilterPannel('date')" :class="{ active: showDateChoose, working: showDateChoose }">
        <span>{{ dateValue }}</span>
        <kd-icon icon="triangle"></kd-icon>
      </div>
    </div>

    <FilterPannel
      v-if="showClazzChoose"
      type="class"
      :multiple="true"
      :value="batchProcessQuery.class_ids"
      :visible.sync="showClazzChoose"
      :options="classOptions"
      @confirm="updateClazzHandle"
      @reset="resetClazzHandle"
    />

    <FilterPannel
      v-if="showSelectType"
      :value="batchProcessQuery.leave_type"
      :visible.sync="showSelectType"
      :options="leaveTypeOptions"
      @confirm="updateTypeHandle"
      @reset="resetTypeHandle"
    />

    <FilterPannel
      v-if="showDateChoose"
      :visible.sync="showDateChoose"
      :value="batchProcessQuery.date"
      :startDate="batchProcessQuery.start_time"
      :endDate="batchProcessQuery.end_time"
      :options="dateOptions"
      title="时间选择"
      type="date-range"
      @confirm="updateDateHandle"
      @reset="resetDateHandle"
    />

    <!-- <kd-picker :visible.sync="showClazzChoose" :options="classOptions" @change="updateClazzHandle"></kd-picker> -->
  </div>
</template>
<script lang="ts">
import { Component, BaseComponent, Prop } from 'kuaidong-component'
import { KdIcon, KdInput, KdPopup, KdPicker } from 'kuaidong-ui'
import { ClassService } from 'kuaidong-service'
import { Clazz } from 'kuaidong-model'

import FilterPannel from './FilterPannel.vue'

@Component({
  components: {
    KdIcon,
    KdInput,
    KdPopup,
    KdPicker,
    FilterPannel,
  },
})
export default class ApprovalLeaveListSearchBar extends BaseComponent {
  @Prop({ required: true })
  clazzs!: Clazz[]

  @Prop({ required: true })
  typeOptions!: any[]

  @Prop({ required: true })
  batchProcessQuery!: {
    keyword: string
    class_ids: string[]
    leave_type: string
    date: string
    start_time?: Date
    end_time?: Date
  }

  searchText = ''

  showSelectType = false
  showClazzChoose = false
  showDateChoose = false

  dateOptions = [
    { label: '近一月', value: 'last_1_month' },
    { label: '近三个月', value: 'last_3_months' },
    { label: '近半年', value: 'last_half_year' },
    { label: '近一年', value: 'last_1_year' },
  ]

  textChangeHandle() {
    this.$emit('query', this.batchProcessQuery)
  }

  updateTypeHandle(val: string) {
    this.$emit('query', { ...this.batchProcessQuery, leave_type: val })
  }

  resetTypeHandle() {
    this.$emit('query', { ...this.batchProcessQuery, leave_type: '' })
  }

  updateClazzHandle(val: any) {
    // if (val && val.length === 2) {
    //   // -3 说明全部
    //   this.$emit('query', { ...this.batchProcessQuery, clazzId: val[1] > 0 ? `${val[1]}` : '' })
    // }
    this.$emit('query', { ...this.batchProcessQuery, class_ids: val })
  }

  resetClazzHandle() {
    this.$emit('query', { ...this.batchProcessQuery, class_ids: [] })
  }

  updateDateHandle(val: string, date: [Date, Date]) {
    const params =
      val === 'custom'
        ? {
            date: val,
            start_time: date[0],
            end_time: date[1],
          }
        : {
            date: val,
            start_time: null,
            end_time: null,
          }
    this.$emit('query', { ...this.batchProcessQuery, ...params })
  }

  resetDateHandle() {
    this.$emit('query', {
      ...this.batchProcessQuery,
      date: 'last_1_month',
      start_time: null,
      end_time: null,
    })
  }

  get optionsVisible() {
    return this.showSelectType || this.showClazzChoose || this.showDateChoose
  }

  get classOptions() {
    const res = ClassService.buildClassOptions(this.clazzs, false, false)
    console.log('res', res)
    return res
  }

  get leaveTypeOptions() {
    return [{ label: '全部', value: '' }, ...this.typeOptions]
  }

  get showTypeValue() {
    if (this.batchProcessQuery.leave_type) {
      const item = this.leaveTypeOptions.find((x) => x.value === this.batchProcessQuery.leave_type)
      if (item) {
        return item.label
      }
    }
    return '全部'
  }

  get showClazzValue() {
    // if (this.batchProcessQuery.clazzId) {
    //   const item = this.clazzs.find((x) => `${x.id}` === this.batchProcessQuery.clazzId)
    //   if (item) {
    //     return this._show_clazz_name(item)
    //   }
    // }
    return '我的班级'
  }

  get dateValue() {
    if (this.batchProcessQuery.date) {
      const item = this.dateOptions.find((x) => x.value === this.batchProcessQuery.date)
      if (item) {
        return item.label
      }
    }
    return '自定义'
  }

  toggleFilterPannel(type?: 'date' | 'type' | 'clazz') {
    if (type === 'date') {
      this.showSelectType = false
      this.showClazzChoose = false
      this.$nextTick(() => {
        this.showDateChoose = !this.showDateChoose
      })
    } else if (type === 'type') {
      this.showDateChoose = false
      this.showClazzChoose = false
      this.$nextTick(() => {
        this.showSelectType = !this.showSelectType
      })
    } else if (type === 'clazz') {
      this.showDateChoose = false
      this.showSelectType = false
      this.$nextTick(() => {
        this.showClazzChoose = !this.showClazzChoose
      })
    } else {
      this.showDateChoose = false
      this.showSelectType = false
      this.showClazzChoose = false
    }
  }
}
</script>
<style lang="less" scoped>
.approval-leave-list-search-bar {
  padding: 20px 0 0;
  background-color: white;
  position: relative;

  .content {
    display: flex;
    background-color: #f7f8fa;
    border-radius: 32px;
    line-height: 32px;
    margin: 0 16px;

    > div {
      &:first-child {
        padding: 0 10px 0 20px;
        font-size: 18px;
      }
      &:last-child {
        flex: 1;
        margin-right: 20px;
        background-color: #f7f8fa;
        border: none;
        min-height: 32px;
      }
    }
  }
  .select {
    padding: 18px 16px 16px;
    display: flex;
    border-bottom: 1px solid #eee;
    > div {
      color: #2d2f33;
      font-size: 12px;
      font-weight: 400;
      flex: 1;
      &.active {
        color: #3366ff;
      }
      &.working {
        .kd-icon {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
